var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTokenPocketWallet = function SvgTokenPocketWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    width: 32,
    color: "text",
    xmlns: "http://www.w3.org/2000/svg",
    className: "token-pocket-wallet_svg__sc-bdnxRM token-pocket-wallet_svg__kDWlca"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.329 35.355V21.713H19.093c-.512 0-.853.341-.853.853v19.268c0 .512.341.853.853.853h9.719v35.126c0 .511.341.852.852.852h15.858c.512 0 .853-.34.853-.852V35.355h-2.046Z",
    fill: "#29AEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.892 17.28H39.213c-.511 0-.852.34-.852.852V73.38c0 .512.34.853.852.853h15.858c.512 0 .853-.341.853-.853V59.397h6.138c11.596 0 20.974-9.378 20.974-20.973 0-11.766-9.549-21.144-21.144-21.144Z",
    fill: "#2761E7"
  })));
};
export default SvgTokenPocketWallet;